<!-- src/components/ProgressBar.svelte -->
<script>
  export let initialStock = 100; // Default value
  export let currentStock = 100; // Default value

  // Reactive calculation of progress and clamping between 0 and 100
  $: progress = initialStock === 0 ? 0 : Math.max(0, Math.min((currentStock / initialStock) * 100, 100));

  // Compute display progress:
  // - 100% only if full stock
  // - 0% only if no stock
  // - Otherwise, show one decimal place without rounding up to 100%
  $: displayProgress = (currentStock === initialStock)
    ? 100
    : (currentStock === 0)
      ? 0
      : parseFloat(progress.toFixed(1));

  // Debugging Log
  // $: console.log(`ProgressBar - Current: ${currentStock}, Initial: ${initialStock}, Progress: ${progress}%, Display: ${displayProgress}%`);
</script>

<style>
  .progress-container {
    position: relative;
    width: 100%;
    height: 30px;
    background-color: #ddd; /* Grey for used stock */
    border-radius: 15px;
    overflow: hidden;
    margin: 10px 0;
  }

  .progress-bar {
    height: 100%;
    background-color: #fe1100; /* Red for remaining stock */
    width: 0%; /* Initial width */
    transition: width 0.5s ease;
    box-sizing: border-box;
  }

  p {
    margin: 0;
    z-index: 1;
    position: absolute;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    /* Default color */
    color: white;
    font-weight: 600;
    text-align: center;
    font-size: 14px;
  }

  /* Classes for text color */
  .text-black {
    color: black;
  }

  .text-white {
    color: white;
  }
</style>

<div class="progress-container" role="progressbar" aria-valuenow="{progress}" aria-valuemin="0" aria-valuemax="100">
  <!-- Red bar showing remaining stock with direct width styling -->
  <div
    class="progress-bar"
    style="width: {progress}%"
    aria-hidden="true"
  ></div>

  <!-- Percentage Text with conditional class and precise display -->
  <p class={progress <= 50 ? 'text-black' : 'text-white'}>
    {displayProgress}% Remaining
  </p>
</div>
